import Route from '@ember/routing/route';

export interface SharedChatModel {
	shareToken: string;
}

export default class SharedChatRoute extends Route {
	override beforeModel(): void {
		document.body.id = 'page-shared-chat';
	}

	override model(params: { share_token: string }): SharedChatModel {
		const { share_token } = params;
		return { shareToken: share_token };
	}
}
